import React, { Component } from "react";
import classNames from "classnames";
import { IYourPdfButtonComponentProps } from "../types/props";
import "./yourPdfButtonComponent.scss";

class BrochureYourPdfButtonComponent extends Component<IYourPdfButtonComponentProps> {
  render() {
    if (!this.props.trayOpen) {
      return (
        <button className={classNames({
          "pdf-button" : true,
        })} onClick={this.openTray}>
          Your PDF <span>({this.props.count})</span>
        </button>
      );
    }
    return null;
  }
  openTray = () => {
    this.props.openTray();
  };
}

export default BrochureYourPdfButtonComponent;
